<template>
  <div class="form-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Form Section -->
    <section class="form-section">
      <div class="container">
        <div class="form-content">
          <PageTitle title="Add Another Vehicle?" />
          <p class="form-subtitle">(Save Additional 20%)</p>
          
          <div class="form-options">
            <button 
              :class="['form-option-button', { 'selected': selectedOption === 'add' }]"
              @click="selectOption('add')"
            >
              Add another vehicle
            </button>
            
            <button 
              :class="['form-link-button', { 'selected': selectedOption === 'no' }]"
              @click="selectOption('no')"
            >
              No, thanks
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'FormPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedOption: null,
      userQuoteData: null
    }
  },
  mounted() {
    this.loadUserData()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    async selectOption(option) {
      this.selectedOption = option
      
      console.log('Selected option:', option)
      
      if (option === 'add') {
        // 添加另一个车辆的逻辑
        console.log('User wants to add another vehicle')
        
        // 保存当前第一辆车的信息到主数据结构
        if (!this.userQuoteData.vehicles) {
          this.userQuoteData.vehicles = []
        }
        
        // 设置添加车辆模式
        this.userQuoteData.adding_vehicle = true
        this.userQuoteData.add_another_vehicle = 'add'
        
        // 清空临时车辆数据，准备收集新车辆信息
        this.userQuoteData.temp_vehicle = {
          car_year: '',
          car_make: '',
          car_model: '',
          car_own: ''
        }
        
        this.saveUserData()
        
        // 提交数据并记录页面提交事件
        await submitDataAndLog('form')
        // 跳转到年份选择页面开始新车辆流程
        this.$router.push('/year')
      } else if (option === 'no') {
        // 用户不想添加更多车辆，跳转到保险页面
        console.log('User does not want to add another vehicle')
        this.userQuoteData.add_another_vehicle = 'no'
        this.userQuoteData.adding_vehicle = false
        this.saveUserData()
        // 提交数据并记录页面提交事件
        await submitDataAndLog('form')
        this.$router.push('/insurance')
      }
    },
    
    goBack() {
      this.$router.push('/own')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.form-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}


/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Form Section */
.form-section {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.form-content {
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
}

.form-subtitle {
  color: #666;
  font-size: 1.1rem;
  margin-bottom: 3rem;
  font-weight: 400;
}

.form-options {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
  align-items: center;
}

.form-option-button {
  padding: 1.5rem 3rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 1.1rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-width: 300px;
  min-height: 70px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.form-option-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.form-option-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

.form-link-button {
  background: none;
  border: none;
  color: #666;
  font-size: 1rem;
  font-weight: 400;
  text-decoration: underline;
  cursor: pointer;
  transition: color 0.3s ease;
  padding: 0.5rem 1rem;
}

.form-link-button:hover {
  color: #333;
}

.form-link-button.selected {
  color: #007bff;
  font-weight: 600;
}

/* Responsive Design */
@media (max-width: 768px) {
  .form-options {
    gap: 1rem;
    padding: 0 1rem;
  }

  .form-option-button {
    padding: 1.2rem 2rem;
    font-size: 1rem;
    min-width: 250px;
    min-height: 60px;
  }

  .form-subtitle {
    font-size: 1rem;
    margin-bottom: 2rem;
  }

  .form-section {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {
  .form-options {
    gap: 0.8rem;
  }

  .form-option-button {
    padding: 1rem 1.5rem;
    font-size: 0.95rem;
    min-width: 200px;
    min-height: 55px;
  }

  .form-link-button {
    font-size: 0.9rem;
  }

  .form-section {
    padding: 1rem 0;
  }
}
</style>
